import { SectionHeader } from "./SectionHeader";

const TESTIMONIALS = [
    {
        initials: "ME",
        name: "Mara Ellison",
        handle: "@marae_dev",
        role: "Head of Platform, RelayStack",
        quote: "Remembered found the path our agents kept re-deriving. Same tasks, a third of the turns, and the pass rate went up. It just compounds.",
        date: "Oct 2",
    },
    {
        initials: "DO",
        name: "Dev Okafor",
        handle: "@devokafor",
        role: "Founding Engineer, Forgebase",
        quote: "Most memory tools store what happened. This stores how the work got done. Our support agent stopped re-investigating the same refunds every morning.",
        date: "Sep 28",
    },
    {
        initials: "LV",
        name: "Lena Voss",
        handle: "@lenavoss",
        role: "CTO, Quantleaf",
        quote: "Recall adds about 60ms and saves us whole reasoning loops. The savings panel is the first thing I check every day.",
        date: "Sep 21",
    },
    {
        initials: "KA",
        name: "Kenji Arata",
        handle: "@kenji_builds",
        role: "Indie Hacker, Driftworks",
        quote: "I pointed it at Claude Code, ran enable, and forgot about it. A week later my agent was finishing chores in half the turns.",
        date: "Sep 17",
    },
    {
        initials: "RS",
        name: "Rhea Saldanha",
        handle: "@rhea_s",
        role: "AI Lead, Helios Labs",
        quote: "The transcript never leaves the machine. That one line is why our security review took an afternoon instead of a quarter.",
        date: "Sep 11",
    },
    {
        initials: "TM",
        name: "Tomas Meyer",
        handle: "@tmeyer_eng",
        role: "Staff Engineer, Northwind AI",
        quote: "A procedure one agent recorded got recalled by four others on the same store. Multi-agent memory without a meeting about it.",
        date: "Sep 4",
    },
];

const Testimonials = () => (
    <section id="testimonials" data-testid="testimonials-section" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
            <SectionHeader id="testimonials">What People Say</SectionHeader>
            <div className="grid gap-px border border-[#262626] bg-[#262626] sm:grid-cols-2 lg:grid-cols-3">
                {TESTIMONIALS.map((t, i) => (
                    <figure
                        key={t.handle}
                        data-testid={`testimonial-card-${i}`}
                        className="group flex min-h-[220px] flex-col bg-[#050505] p-7 transition-colors duration-200 hover:bg-[#0a0a0a]"
                    >
                        <div className="flex items-center gap-3">
                            <span className="flex h-10 w-10 items-center justify-center border border-[#262626] bg-[#0a0a0a] font-mono text-xs font-semibold text-green-400">
                                {t.initials}
                            </span>
                            <div>
                                <figcaption className="text-sm font-medium text-neutral-100">{t.name}</figcaption>
                                <span className="font-mono text-[11px] text-neutral-500">{t.handle}</span>
                            </div>
                        </div>
                        <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-600">
                            {t.role}
                        </span>
                        <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-neutral-300">
                            "{t.quote}"
                        </blockquote>
                        <span className="mt-4 font-mono text-[10px] text-neutral-600">{t.date}</span>
                    </figure>
                ))}
            </div>
        </div>
    </section>
);

export default Testimonials;
